import { Key } from '@briebug/ngrx-auto-entity';

export class UserRole {
  @Key id: number;
  role: string;
}
